import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';

import { StyledContainer, Banner, Img, Content, Heading, Body } from './styles';

const AwardBanner = ({ data }) => {
  if (!data) return false;

  const { imageDam, bodyCopy, backgroundColor, heading, headingAlignment } =
    data;

  return (
    <StyledContainer backgroundColor={backgroundColor}>
      <Banner>
        {imageDam && <Img src={imageDam} alt={imageDam.altText || ''} />}
        {(bodyCopy || heading) && (
          <Content>
            {heading && (
              <Heading $headingAlignment={headingAlignment}>
                <RichText document={heading} />
              </Heading>
            )}
            {bodyCopy && (
              <Body>
                <RichText document={bodyCopy} />
              </Body>
            )}
          </Content>
        )}
      </Banner>
    </StyledContainer>
  );
};

AwardBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default AwardBanner;
